import { render, staticRenderFns } from "./PublisherDashboardSectionWrapper.vue?vue&type=template&id=30fbab17&"
import script from "./PublisherDashboardSectionWrapper.vue?vue&type=script&lang=js&"
export * from "./PublisherDashboardSectionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PublisherDashboardSectionWrapper.vue?vue&type=style&index=0&id=30fbab17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports